// extracted by mini-css-extract-plugin
export default {"optionContainer":"SettingsContainer_optionContainer__IAm8t"};